export default [
  {
    path: '/feedback',
    name: 'feedback-stats',
    component: () => import('@/views/feedback/FeedbackStats.vue'),
  },
]
